import styled, { createGlobalStyle } from "styled-components";
import Slick from "react-slick";

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  position: fixed;
  max-width: 400px;
  height: 100%;
  margin: 0 auto;

  z-index: 100;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #090909;

  box-sizing: border-box;
`;

export const Header = styled.header`
  height: 44px;
  padding: 0;
  margin-right: 16px;

  & div {
    margin-right: 16px;
    margin-top: 16px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    color: #fff;

    & img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const SlickWrapper = styled.div`
  /* margin-left: -16px; */

  width: 100%;

  position: absolute;
  /* top: 50%; */
`;

export const SlickComponent = styled(Slick)`
  width: 100%;
`;

export const ImgWrapper = styled.div`
  width: 100%;
  & img {
    width: 100% !important;
    height: 100%;
  }
`;

export const Indicator = styled.div`
  margin-top: 12px;
  text-align: center;

  & > div {
    width: 75px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    color: white;
    font-size: 15px;

    & span {
      color: #ff7a00;
    }
  }
`;

export const Global = createGlobalStyle`
.slick-slide {
    display: inline-block;
}
`;
